import axios from "axios";
import { Loading, Notify } from "notiflix";
import { CITY_LIST, JOB_LIST, PORTFOLIO ,INTERN_JOB_LIST,UPDATE_JOB_APPLICATION_STATUS,JOB_DETAILS} from "./types";
import { APIURL } from "./config";
import { getQueryString } from "../../helper";

export const fetchJob = (params,type,payload) => async dispatch => {
const queryString = getQueryString(params)
   const config = {
      headers: {
         'ContentType': 'application/json',
      }
   }
  try {
    Loading.standard();
    const res = await axios.post(`${APIURL}/api/student/job/list?${queryString}`, payload, config);
    Loading.remove();
    if (res?.data?.status) {
      dispatch({
        type: type == "fulltime" ? JOB_LIST : INTERN_JOB_LIST,
        payload: res?.data?.data
      });
    //   if (cb && res?.data?.body?.length) cb(res?.data?.body?.[0]?.id);
    }else{
      dispatch({
        type: type == "fulltime" ? JOB_LIST : INTERN_JOB_LIST,
        payload: []
      });
    }

  } catch (err) {
    Loading.remove();
    const message = err?.response?.data?.message ?? "internal server error";
    Notify.failure(message);
  }
}


export const fetchSingleJob = (params) => async dispatch => {
  const config = {
    headers: {
      'ContentType': 'application/json',
    },
    data: {}
  };
  const queryString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
  try {
    Loading.standard();
    // const res = await axios.get(`${APIURL}/api/entity/kid/profile/nologin?${queryString}`, config); 
    const res = await axios.get(`${APIURL}/api/student/job/details?${queryString}`, config);
    Loading.remove();
    
    if (res?.data?.data) {
      dispatch({
        type: JOB_DETAILS,
        payload: res?.data?.data
      });
    } else {
      dispatch({
        type: JOB_DETAILS,
        payload: []
      });
    }

  } catch (err) {
    Loading.remove();
    const message = err?.response?.data?.message ?? "internal server error";
    Notify.failure(message);
  }
}

export const applyJob = params => async dispatch => {
const queryString = getQueryString(params)
  const config = {
    headers: {
      'ContentType': 'application/json',
    },
    data: {}
  }
  try {
    Loading.standard();
    const res = await axios.post(`${APIURL}/api/student/job/apply?${queryString}`, config);
    Loading.remove();
    if (res?.data?.status) {
      dispatch({
      type: 'UPDATE_JOB_APPLICATION_STATUS',
      payload: {
        job_id: params.job_id,
        application_status: 'APPLICATION_SENT'
      }
    });
    }

  } catch (err) {
    Loading.remove();
    const message = err?.response?.data?.message ?? "internal server error";
    Notify.failure(message);
  }
}

export const withdrawJob = params => async dispatch => {
const queryString = getQueryString(params)
  const config = {
    headers: {
      'ContentType': 'application/json',
    },
    data: {}
  }
  try {
    Loading.standard();
    const res = await axios.post(`${APIURL}/api/student/job/withdraw?${queryString}`, config);
    Loading.remove();
    if (res?.data?.status) {
      dispatch({
      type: 'UPDATE_JOB_APPLICATION_STATUS',
      payload: {
        job_id: params.job_id,
        application_status: 'WITHDRAWN'
      }
    });
    }

  } catch (err) {
    Loading.remove();
    const message = err?.response?.data?.message ?? "internal server error";
    Notify.failure(message);
  }
}

export const getCityList = () => async dispatch => {

  const config = {
    headers: {
      'ContentType': 'application/json',
    },
    data: {}
  };
  try {
    const res = await axios.get(`${APIURL}/api/city`, config);
    if (res?.data?.status) {
      dispatch({
        type: CITY_LIST,
        payload: res?.data?.data
      })
    } else if (res?.data?.message) {
      Notify.warning(res?.data?.message);
    } else {
      Notify.warning("something went wrong");
    }

  } catch (err) {
    console.log("err >>", err);
  }
}